<template>
    <div style="position:relative" id="status_and_workflow">
        <div class="workflow_action">
            <h3>Orientation actions required</h3>

            <p>Based on the approved accommodations for this student, the following documents must be uploaded before orientation is complete.</p>

            <ul v-if="missingDocuments.length" class="missing-document-list">
                <li v-for="(missingDocument,index) in missingDocuments" :key="index">{{ missingDocument }}</li>
            </ul>

            <p>If too much time has passed with no action, you may</p>

            <el-button type="primary" size="small" @click="showStatusChangeFields = true">Change status to Inactive</el-button>
            <el-form v-if="showStatusChangeFields">
                <el-form-item>
                    <span class="inactive-inputs-label">Reason: </span>
                    <el-select size="small" v-model="inactiveReason" class="workflow-input">
                        <el-option v-for="reason in inactiveReasons" :key="reason.name" :value="reason.name" :label="reason.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <span class="inactive-inputs-label">Comment: </span>
                    <el-input size="small" v-model="inactiveComment" class="workflow-input"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onChangeStatus('inactive')">Deactivate</el-button>
                </el-form-item>
            </el-form>
            <student-student-workflow-system-administrator-options :id="id" :studentName="studentName" v-on:refreshstudent="refreshStudent"></student-student-workflow-system-administrator-options>
        </div>
   </div>
</template>
<script>
    import axios from 'axios'



    export default {
        components: {

        },
        data() {
            return {
                inactiveComment: null,
                inactiveReason: null,
                inactiveReasons: [],
                showStatusChangeFields: false,
                missingDocuments: []
            }
        },
        props: ['id', 'studentName'],
        methods: {
            load: function () {
                axios.get("/api/simple/get-inactive-reasons/")
                    .then(response => {
                        this.inactiveReasons = response.data.rows;
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
                axios.get("/api/student/workflow-information/", {params:{id: this.id}})
                    .then(response => {
                        this.missingDocuments = response.data.missingDocumentList;
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            },
            onChangeStatus: function(newStatus) {
                this.$message.closeAll();

                axios.put("/api/student/change-status/", {
                        id: parseInt(this.id),
                        new_status: newStatus,
                        inactive_reason: this.inactiveReason,
                        inactive_comment: this.inactiveComment
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.$emit('refreshstudent');
                        } else {
                            this.$message({
                                showClose: true,
                                duration: 20000,
                                type: 'error',
                                message: response.data.message
                            });
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            },
            refreshStudent: function(){
                this.$emit('refreshstudent');
            }
        },
        mounted() {
            this.load()
        }
    }
</script>
<style scoped>
    .workflow-input {
        width:300px;
    }
    .workflow-input-large {
        width:325px;
    }
    .workflow-input-small {
        width:175px;
    }
    .workflow_action .el-form-item__label {
        padding:0px;
        line-height:130%;
    }
    .bottom-margin {
        margin-bottom:3px;
    }
    .missing-document-list{
        text-align: left;
    }
</style>